var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series.length > 0)?_c('div',{staticClass:"chart-container w-100"},[_c('apexchart',{attrs:{"type":"bar","height":"400","options":_vm.chartOptions,"series":_vm.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }